import styles from './Templates.module.css';

import config from 'config.js';
import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { PageHeader, Card, Spin, Button, Input, Collapse, Upload, Col, Modal, Form, Menu, Dropdown, Select, List, message, Avatar, Typography } from 'antd';

import {
  ReloadOutlined,
  SettingOutlined,
  DeleteOutlined,
  UploadOutlined
} from '@ant-design/icons';

import {
  getTemplates, getTemplateCategories,
  createTemplate, createTemplateCategory,
  removeTemplate, removeTemplateCategory
} from 'store/ducks/templates.js';

import {
  getForms
} from 'store/ducks/forms.js';

const { Panel } = Collapse;
const { Option } = Select;

const Templates = () => {
  const dispatch = useDispatch();

  const [showAddCategory, setShowAddCategory] = useState(false);
  const [showCreateTemplate, setShowCreateTemplate] = useState(false);

  const [activeTemplateCategory, setActiveTemplateCategory] = useState(null);

  const [addCategoryInput, setAddCategoryInput] = useState('');

  const [createTemplateFormClassic, setCreateTemplateFormClassic] = useState(null);
  const [createTemplateFormConversational, setCreateTemplateFormConversational] = useState(null);
  const [createTemplateName, setCreateTemplateName] = useState('');
  const [createTemplateDescription, setCreateTemplateDescription] = useState('');
  const [createTemplateImage, setCreateTemplateImage] = useState('');
  const [createTemplateFileList, setCreateTemplateFileList] = useState([]);

  const getTemplatesLoading = useSelector(state => state.templates.getTemplates.loading);
  const getTemplateCategoriesLoading = useSelector(state => state.templates.getTemplateCategories.loading);
  const createTemplateCategoryLoading = useSelector(state => state.templates.createTemplateCategory.loading);
  const createTemplateLoading = useSelector(state => state.templates.createTemplate.loading);

  const forms = useSelector(state => state.forms.forms);
  const templates = useSelector(state => state.templates.templates);
  const templateCategories = useSelector(state => state.templates.templateCategories);

  const reload = () => {
    dispatch(getTemplates());
    dispatch(getTemplateCategories());
    dispatch(getForms({
      owner: config.adminHolder,
      themeType: 'stock'
    }));
  };

  useEffect(() => {
    reload();
  }, []);

  const menu = (id) => <Menu>
    <Menu.Item danger onClick={() => deleteTemplateCategory(id)}>Delete</Menu.Item>
  </Menu>;

  const openAddCategoryModal = () => setShowAddCategory(true);
  const openCreateTemplateModal = () => setShowCreateTemplate(true);;

  const closeAddCategory = () => {
    setShowAddCategory(false);
    setAddCategoryInput('');
  };

  const submitAddCategory = () => {
    dispatch(createTemplateCategory({
      name: addCategoryInput
    })).then(() => {
      closeAddCategory();
      reload();
    });
  };

  const submitCreateTemplate = () => {
    dispatch(createTemplate({
      name: createTemplateName,
      description: createTemplateDescription,
      category: activeTemplateCategory,
      formClassic: createTemplateFormClassic,
      formConversational: createTemplateFormConversational,
      image: createTemplateImage
    })).then(() => {
      closeCreateTemplate();
      reload();
    });
  };

  const closeCreateTemplate = () => {
    setShowCreateTemplate(false);
    setCreateTemplateFormClassic(null);
    setCreateTemplateFormConversational(null);
    setCreateTemplateName('');
    setCreateTemplateDescription('');
    setCreateTemplateImage('');
    setCreateTemplateFileList([]);
  };

  const deleteTemplate = (id) => {
    dispatch(removeTemplate(id)).then(() => reload());
  };

  const deleteTemplateCategory = (id) => {
    dispatch(removeTemplateCategory(id)).then(() => reload());
  };

  const genExtra = (id) => <Dropdown overlay={menu(id)}>
    <SettingOutlined />
  </Dropdown>;

  const handleUploadChange = (info) => {
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);

      setCreateTemplateImage(info.file.response.url);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }

    setCreateTemplateFileList([...info.fileList]);
  }

  return (
    <>
      <PageHeader
        title="Templates"
        style={{ border: '1px solid #f0f0f0', background: '#fff', margin: '0 0 15px 0' }}
        extra={[
          <Button type="primary" ghost key="mails" target="_blank" onClick={() => openAddCategoryModal()}>Add Category</Button>,
          <Button onClick={() => reload()}><ReloadOutlined /></Button>
        ]}
      />

      <Spin spinning={getTemplateCategoriesLoading || getTemplatesLoading} size="large">
        <Card style={{ width: '100%', minHeight: 224, padding: '40px 0 0 0' }}>
          <Collapse accordion onChange={(id) => setActiveTemplateCategory(id)} expandIconPosition="left">
            {templateCategories && templateCategories.map((category) => {
              return <Panel header={category.name} key={category._id} extra={genExtra(category._id)}>
                {templates && <List bordered
                  dataSource={templates.filter((template) => template.category === category._id)}
                  renderItem={(item) => {
                    if (!forms || forms.lenght === 0) return <></>;

                    const classicForms = forms.filter((form) => form.type === 'classic');
                    const conversationalForms = forms.filter((form) => form.type === 'conversational');

                    const selectedClassicForm = classicForms.find((f) => f._id === item.formClassic);
                    const selectedConversationalForm = conversationalForms.find((f) => f._id === item.formConversational);

                    return <List.Item key={item._id}>
                      <List.Item.Meta
                        avatar={<Avatar shape="square" size={64} src={item.image} />}
                        title={<>{item.name} <Typography.Text code>{item._id}</Typography.Text></>}
                        description={<>
                          {item.description && <>
                            <Typography.Text type="secondary">{item.description}</Typography.Text>
                            <br />
                          </>}

                          Traditional: {selectedClassicForm ? <Link to={`/forms/${item.formClassic}`}>{selectedClassicForm.name}</Link> : <Typography.Text type="danger">Form Not Found</Typography.Text>}
                          <br />
                          Conversational: {selectedConversationalForm ? <Link to={`/forms/${item.formConversational}`}>{selectedConversationalForm.name}</Link> : <Typography.Text type="danger">Form Not Found</Typography.Text>}
                        </>}
                      />
                      <div>
                        <Button type="dashed" danger shape="circle" icon={<DeleteOutlined />} onClick={() => deleteTemplate(item._id)} />
                      </div>
                    </List.Item>;
                  }}
                />}

                <Button type="dashed" block style={{ margin: '15px 0 0 0' }} onClick={() => openCreateTemplateModal(category._id)}>Add Template</Button>
              </Panel>;
            })}
          </Collapse>
        </Card>
      </Spin>

      <Modal title="Add Category" visible={showAddCategory} onOk={() => submitAddCategory()} onCancel={() => closeAddCategory()}>
        <Spin spinning={createTemplateCategoryLoading} size="large">
          <Input value={addCategoryInput} onChange={(e) => setAddCategoryInput(e.target.value)} placeholder="Template category name" />
        </Spin>
      </Modal>

      <Modal title="Add Template" visible={showCreateTemplate} onOk={() => submitCreateTemplate()} onCancel={() => closeCreateTemplate()}>
        <Spin spinning={createTemplateLoading} size="large">
          <Input value={createTemplateName} style={{ width: '100%', margin: '0 0 15px 0' }} onChange={(e) => setCreateTemplateName(e.target.value)} placeholder="Template name" />

          <Input.TextArea value={createTemplateDescription} rows={4} style={{ width: '100%', margin: '0 0 15px 0' }} onChange={(e) => setCreateTemplateDescription(e.target.value)} placeholder="Template description" />

          <Select showSearch
            style={{ width: '100%', margin: '0 0 15px 0' }}
            placeholder="Select a traditional form"
            value={createTemplateFormClassic || undefined}
            optionFilterProp="children"
            onChange={(id) => setCreateTemplateFormClassic(id)}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {forms && forms.filter((form) => form.type === 'classic').map((form) => <Option key={form._id} value={form._id}>{form.name}</Option>)}
          </Select>

          <Select showSearch
            style={{ width: '100%', margin: '0 0 15px 0' }}
            placeholder="Select a conversational form"
            value={createTemplateFormConversational || undefined}
            optionFilterProp="children"
            onChange={(id) => setCreateTemplateFormConversational(id)}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {forms && forms.filter((form) => form.type === 'conversational').map((form) => <Option key={form._id} value={form._id}>{form.name}</Option>)}
          </Select>

          <Upload name="file"
            disabled={createTemplateImage}
            action={`${config.apiUrl}/api/admin/templates/image`}
            accept="image/png, image/jpeg"
            listType="picture"
            fileList={createTemplateFileList}
            headers={{
              'Authorization': `Bearer ${localStorage.getItem('user_token')}`
            }}
            onChange={handleUploadChange}>
            {!createTemplateImage && <Button disabled={createTemplateImage}>
              <UploadOutlined /> Click to Upload Image
            </Button>}
          </Upload>
        </Spin>
      </Modal>
    </>
  );
}

export default Templates;
